import React, { useState, useContext } from "react";

// External
import _ from "lodash";

// Material-UI
import { makeStyles } from "@material-ui/core/styles";

// Components
import { ModuleWrapperContext } from "@Components/ModuleWrapper/ModuleWrapperContext";

// Styles
import { moduleListing } from "@Styles/ModuleListing";

// Internal
import Language from "sccLanguage";
import TakForm from "./TakForm";
import TakList from "./TakList";

const useStyles = makeStyles((theme) => ({
  ...moduleListing(theme),
}));

const MW_LIST_MODE = process.env.REACT_APP_MW_LIST_MODE;

export default function ModuleWrapperTakBody(props) {
  const [mwState] = useContext(ModuleWrapperContext);
  const [openDetailsFor, setOpenDetailsFor] = useState(null);
  const takServersOnly = getTakServersOnly(mwState.filteredModuleData);
  const filteredModuleData = mwState.convertAndSort(
    takServersOnly,
    mwState.searchField
  );

  function getTakServersOnly(filteredModuleData) {
    return Object.fromEntries(
      Object.entries(filteredModuleData).filter(
        ([_, item]) => item.typeID === 1
      )
    );
  }

  const handleClick = (id) => {
    openDetailsFor !== id ? setOpenDetailsFor(id) : setOpenDetailsFor(null);
  };

  const classes = useStyles();

  return mwState.wrapperDisplayMode === MW_LIST_MODE ? (
    <ul className={classes.listContainer}>
      {!_.isEmpty(filteredModuleData) ? (
        filteredModuleData
          .slice(mwState.pagination.startIndex, mwState.pagination.endIndex)
          .map((data) => {
            return (
              <TakList
                key={data.id}
                data={data}
                handleClick={handleClick}
                openDetailsFor={openDetailsFor}
              />
            );
          })
      ) : (
        <div className="noResults">{Language.translate("No Results!")}</div>
      )}
    </ul>
  ) : (
    <TakForm />
  );
}
